module.exports = __webpack_public_path__ + "static/media/cash_icon.9f916167.svg";